import React, { useState } from 'react';
import { useViewport } from 'hooks/3catinfo/useViewport';
import { getDataUTC, is3CatInfoVerificacio } from '@portal-internet/core';
import { getNaturalDate } from 'utils/3catinfo/dateHelper';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import Players from 'components/3catinfo/Players';
import IconaMedia from 'components/3catinfo/IconaMedia';
import Etiqueta from 'components/3catinfo/Etiqueta';
import Etiquetes from 'components/3catinfo/Etiquetes';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatHoritzontal.module.scss';

const MediaImatge = (props) => {
    const { item, priorityImage, numColumnsRow, estil, exclou } = props;
    const { id, canals_directes_embedats, videos, audios, imatges, imatgeSrc, imatgeAlt, mediadestacat, agrupacions, tags } =
        item || props;
    const { viewport, typesViewport } = useViewport();

    const etiqueta = canals_directes_embedats ? (
        <div className={styles.labelWrapper} data-testid='etiqueta'>
            <Etiqueta className={styles.labelDirecte} text='En directe' icona='directes' isBlanc={true} tipus='highlight' />
        </div>
    ) : (
        <div className={styles.labelWrapper} data-testid='etiqueta'>
            <Etiquetes agrupacions={agrupacions} tags={tags} id={id} exclou={exclou} />
        </div>
    );

    const tipusImatge =
        viewport === typesViewport.VP_SMALL && estil !== 'fixHoritzontal' ? 'web_destacat' : 'web_destacat_horitzontal';

    return (
        <>
            {etiqueta}
            <IconaMedia
                videos={videos}
                audios={audios}
                canals_directes_embedats={canals_directes_embedats}
                mediadestacat={mediadestacat}
            />
            <Imatge
                className={styles.imatge}
                imatges={imatges}
                src={imatgeSrc}
                alt={imatgeAlt}
                priorityImage={priorityImage}
                tipus={tipusImatge}
                layout='fill'
                objectFit='cover'
                numColumnsRow={numColumnsRow}
                data_testid='destacat-img'
            />
        </>
    );
};

const Media = (props) => {
    const { item, priorityImage, numColumnsRow, playerEmbedat } = props;
    const { canals_directes_embedats, videos, imatges } = item || props;
    const [amagarEtiqueta, setAmagarEtiqueta] = useState(false);
    const [videoActive, setVideoActive] = useState(true);

    const pushMediaModel = (mediaModel) => {
        const duradaMediaModel =
            __get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.durada.text') ||
            __get(mediaModel, 'attributes.informacio.attributes.arafem.durada.text');
        const geoBlocked = __get(mediaModel, 'attributes.geoblocked');
        setVideoActive(duradaMediaModel !== '' && !geoBlocked);
    };

    const amagarEtiquetaHandler = (state) => {
        setAmagarEtiqueta(state);
    };

    if (!videoActive || !playerEmbedat || (__isEmpty(canals_directes_embedats) && __isEmpty(videos))) {
        return <MediaImatge {...props} />;
    }

    if (playerEmbedat && !__isEmpty(canals_directes_embedats)) {
        return (
            <>
                <div className={styles.mediaVideo} data-testid='destacat-video-directe'>
                    <Players
                        id={getDirecte(canals_directes_embedats[0])?.canal}
                        tipus='video-directe'
                        autoPlay={false}
                        mostrarBotonsAccessibilitat={false}
                        eliminarPrimerTabIndex={true}
                        ocultaInfo={amagarEtiquetaHandler}
                        pushMediaModel={pushMediaModel}
                        imatges={imatges}
                        tagIdPrefix={props.redlAuxInfo?.replaceAll('|', '-')?.toLowerCase() || 'destacat-basic'}
                    />
                </div>
                {!amagarEtiqueta && (
                    <div className={styles.labelWrapper} data-testid='etiqueta'>
                        <Etiqueta
                            className={styles.labelDirecte}
                            text='En directe'
                            icona='directes'
                            isBlanc={true}
                            tipus='highlight'
                        />
                    </div>
                )}
            </>
        );
    } else if (playerEmbedat && !__isEmpty(videos)) {
        return (
            <Players
                id={videos[0].id}
                tipus='destacat'
                imatges={videos[0]?.imatges || imatges}
                numColumnsRow={numColumnsRow}
                priorityImage={priorityImage}
                testId='noticia-media-video'
            />
        );
    }

    return <></>;
};

const Avantitol = (props) => {
    const { mostraComarca, mostraPrograma, mostraTematica, item, avantitol } = props;
    const { programes_tv, programes_radio, tags, comarques } = item;

    const programa = programes_tv?.[0]?.desc || programes_radio?.[0]?.desc;
    const comarca = comarques?.[0]?.desc;
    const mainTheme = tags?.find((t) => t.main)?.desc?.toUpperCase();
    const isVerifica = is3CatInfoVerificacio(tags);

    return (
        <>
            {avantitol && <div className={styles.avantitol}>{avantitol}</div>}
            {isVerifica && <div className={styles.avantitol}>3catinfo verifica</div>}
            {!isVerifica && mostraComarca && comarca && <div className={styles.avantitol}>{comarca}</div>}
            {mostraTematica && mainTheme && <span className={styles.tematica}>{mainTheme}</span>}
            {!isVerifica && mostraPrograma && programa && <div className={styles.avantitol}>{programa}</div>}
        </>
    );
};

const Peu = (props) => {
    const { lloc, autors, programa } = props;

    const stylesPeu = clsx({
        [styles.lloc]: true,
        [styles.ambAutor]: !__isEmpty(programa) || !__isEmpty(autors)
    });

    if (__isEmpty(lloc) && __isEmpty(autors)) return <></>;

    return (
        <div>
            {!__isEmpty(autors) && (
                <span className={styles.autors}>
                    {autors.map((item, i) => {
                        const isFirst = i === 0 && autors.length > 1;
                        const isLast = i === autors.length - 1;
                        const routeAutor = { slug: item?.nom, id: item?.id, tipologia: item?.tipologia };
                        return (
                            <React.Fragment key={item.id}>
                                {!isLast && !isFirst && ', '}
                                {isLast && autors.length > 1 && ' i '}
                                <Enllac route={routeAutor} className={styles.enllacAutor}>
                                    {item.nom}
                                </Enllac>
                            </React.Fragment>
                        );
                    })}
                </span>
            )}
            {!__isEmpty(lloc) && <span className={stylesPeu}>{lloc}</span>}
        </div>
    );
};

const DestacatHoritzontal = (props) => {
    const {
        item,
        positionImg,
        estil,
        inMosaic,
        routePath,
        testId,
        tag = 'h3',
        mostraComarca,
        mostraPrograma,
        mostraTematica,
        mostrarData,
        marcatgeAudienciesClick,
        avantitol,
        playerEmbedat,
        noEnllac = false
    } = props;
    const { id, domini, titol, lloc, permatitle, tipologia, autors, href, programes_tv, programes_radio, data_publicacio } = item;
    const { zoomNavigator, isMobile } = useViewport();
    const TagSeo = tag;
    const programa = programes_tv?.[0]?.desc || programes_radio?.[0]?.desc;
    const route = { slug: permatitle || titol, id: id, tipologia: tipologia, type: routePath, href: href, domini };

    const stylesDestacat = clsx({
        [styles.destacat]: true,
        [styles.inMosaic]: inMosaic,
        [styles.right]: positionImg === 'right',
        [styles.ambZoom]: !isMobile && zoomNavigator > 1.5,
        [styles[estil]]: !!estil,
        [styles.noEnllac]: noEnllac
    });

    const DataPublicacio = (props) => {
        const { mostrarData, date } = props;
        return mostrarData && date ? (
            <time dateTime={getDataUTC(date)} className={styles.dataPub}>
                {getNaturalDate(date)}
            </time>
        ) : (
            <></>
        );
    };

    return item ? (
        <article className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            <div className={styles.wrapper}>
                <div className={styles.imatgeWrapper} data-testid='destacat-content-imatge'>
                    <Media {...props} />
                </div>
            </div>
            <div className={styles.title} data-testid='destacat-titol'>
                <Avantitol
                    mostraComarca={mostraComarca}
                    mostraPrograma={mostraPrograma}
                    mostraTematica={mostraTematica}
                    avantitol={avantitol}
                    item={item}
                />
                <TagSeo className={styles.titol}>
                    <Enllac
                        route={route}
                        dataTestId='destacat-enllac'
                        marcatgeAudienciesClick={marcatgeAudienciesClick}
                        className={styles.enllac}
                    >
                        <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                    </Enllac>
                </TagSeo>
                <DataPublicacio isDirecte={false} mostrarData={mostrarData} date={data_publicacio} className={styles.dataPub} />
                <Peu lloc={lloc} autors={autors} programa={programa} />
            </div>
        </article>
    ) : (
        <></>
    );
};

export default DestacatHoritzontal;